import { Form, useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'

import { TextInput, MediaInput } from 'src/components'
import { ScannerDetailsMap } from './map'
import {
  BatchIdInput,
  ImpactRecord,
  ImpactRecordWithoutSelection,
  MovementInputs,
  SectionRadioButtons,
} from './inputs'
import { useScanRelationContext } from '../form-wrapper/relations-context.component'
import { ECreateScanMode, EScanRecordType, ETranslationNs, IScanCreateForm } from 'src/types'

import { useStyles } from './styles'

export const DetailsForm = () => {
  const [t] = useTranslation(ETranslationNs.ScanForm)
  const { formType, createScanMode } = useScanRelationContext()
  const { setFieldValue, values, handleChange, errors } = useFormikContext<IScanCreateForm>()
  const classes = useStyles()

  return (
    <Form className={classes.detailsForm}>
      <ScannerDetailsMap />
      <SectionRadioButtons />
      <BatchIdInput />
      {formType === EScanRecordType.Movement && <MovementInputs />}

      {formType === EScanRecordType.Impact && createScanMode === ECreateScanMode.Default && (
        <ImpactRecord />
      )}

      {formType === EScanRecordType.Impact && createScanMode !== ECreateScanMode.Default && (
        <ImpactRecordWithoutSelection />
      )}

      <TextInput
        error={errors.note}
        value={values.note}
        handleChange={handleChange}
        multiline
        inputUpperLabel={t('note-input-label.v')}
        inputName="note"
      />
      <MediaInput media={values.media} setFieldValue={setFieldValue} noJourneyOptions />
    </Form>
  )
}
